import React from "react";
import Radium from "radium";
import { FlatButton, IconButton } from "material-ui";

import SearchIcon from "material-ui/svg-icons/action/search";
import ClearIcon from "material-ui/svg-icons/content/clear";
import ViewModuleIcon from "material-ui/svg-icons/action/view-module";
import ViewListIcon from "material-ui/svg-icons/action/view-list";
import StarIcon from "material-ui/svg-icons/toggle/star";
import StarBorderIcon from "material-ui/svg-icons/toggle/star-border";

import Tag from "../tag.jsx";

const STYLES = {
  main: {
    margin: "0 auto"
    // ':hover': {}
  },
  container: {
    display: "flex",
    margin: "0 auto",
    backgroundColor: "#fff",
    padding: "1.5em 2em",
    position: "relative",
    boxShadow: "0 0 2.1rem rgba(69, 77, 93, 0.25)",
    borderRadius: "10px",
    maxWidth: "90vw",
    boxSizing: "border-box",
    zIndex: 998
  },
  filterBox: {
    display: "flex",
    flex: 1,
    alignItems: "center"
  },
  icon: {
    marginRight: "0.5em",
    marginBottom: -2,
    flexShrink: "0"
  },
  input: {
    border: 0,
    outline: 0,
    fontSize: 20,
    fontFamily: "Lato, sans-serif",
    flex: 1,
    transition: "0.5s all ease-in-out",
    width: "100%",
    ":focus": {}
  },
  viewControl: {
    marginTop: 2,
    marginBottom: -12,
    marginLeft: -5,
    flexShrink: 0
  },
  viewIcon: {
    margin: "-12px -12px 0 0"
  },
  subContainer: {
    borderRadius: "10px",
    margin: "-1em auto 0",
    boxShadow: "rgba(69, 77, 93, 0.25) 0px 0px 2.1rem",
    padding: "2em 1.25em 1.25em",
    width: "92%",
    zIndex: 997,
    backgroundColor: "#fff",
    maxWidth: "75vw",
    transition: "0.1s all ease-in-out",
    opacity: 0,
    visbility: "hidden"
  },
  subContainerDisplaySectionMode: {
    textAlign: "center"
  },
  subContainerActive: {
    opacity: 1,
    visibility: "visible"
  }
};

class FilmFilterEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      scrolledPastFilterEditor: false
    };

    this._onSearchChange = this._onSearchChange.bind(this);
  }

  static contextTypes = {
    isLarge: React.PropTypes.bool,
    tenant: React.PropTypes.object
  };

  _onSearchChange(e) {
    let s = e.target.value;
    this.setState({ search: s }, () => {
      this.props.onSearchChange(s);
    });
  }

  componentWillMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentDidMount() {
    // Disabled for now
    // if (this.input) {
    //   this.input.focus();
    // }

    this.listener = window.addEventListener("scroll", () => {
      if (!this.container) {
        return;
      }
      const parentOffset =
          this.container.parentElement.parentElement.parentElement.parentElement
            .offsetTop,
        containerHeight = this.container.offsetHeight;

      this.setState({
        scrolledPastFilterEditor:
          window.scrollY > parentOffset + containerHeight - 64
      });
    });
  }

  componentWillReceiveProps(props) {
    if (props.search && props.search !== this.state.search) {
      this.setState({ search: props.search });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.listener);
  }

  render() {
    const { tags, displaySectionMode, forcedListMode } = this.props;
    const { scrolledPastFilterEditor } = this.state;
    const { isLarge } = this.context;
    const selectedStyle = {
        color: this.context.tenant.invert_colors_alt
          ? "#000"
          : this.context.tenant.palette.primary1Color
      },
      unselectedStyle = this.context.tenant.invert_colors_alt
        ? { color: "#ccc" }
        : null;

    let tagComponents = displaySectionMode
      ? tags.filter(t => typeof t.visible === "undefined" ? true : t.visible).map(t => (
          <FlatButton
            primary
            onClick={() => {
              this.props.onDisplaySectionChange(
                this.props.filterTags[t.id] ? null : t.id
              );
            }}
            label={
              <span>
                {t.name}
                {/* {this.props.filterTags[t.id] && (
                  <ClearIcon
                    style={{
                      verticalAlign: "-3px",
                      marginLeft: 4,
                      width: 15,
                      height: 15,
                      color: "#fff"
                    }}
                  />
                )} */}
              </span>
            }
            labelStyle={Object.assign(
              { verticalAlign: "0px" },
              !isLarge && {
                fontSize: "7pt",
                paddingLeft: "8px",
                paddingRight: "8px"
              }
            )}
            style={Object.assign(
              { border: "1px solid", marginRight: 10, marginTop: 10 },
              this.props.filterTags[t.id] && {
                border: `1px solid ${this.context.tenant.palette.accent1Color}`,
                backgroundColor: `${this.context.tenant.palette.accent1Color}`,
                color: "#ffff"
              },
              !isLarge && {
                paddingLeft: 0,
                paddingRight: 0,
                height: "auto",
                lineHeight: "24px"
              }
            )}
          />
        ))
      : tags.filter(t => typeof t.visible === "undefined" ? true : t.visible).map(t => (
          <Tag
            content={t}
            key={t.id}
            checkable={true}
            disabled={!this.props.filterTags[t.id]}
            style={{ display: "inline-block", whiteSpace: "nowrap" }}
            className="Films--film_filter_editor--tags--tag"
            onClick={() => {
              this.props.onTagChange(t.id, !this.props.filterTags[t.id]);
            }}
          />
        ));

    let hasTagFilters = Object.keys(this.props.filterTags).length > 0,
      inputFocused = Radium.getState(this.state, "input", ":focus");
    // mainHovered = Radium.getState(this.state, 'main', ':hover');

    return (
      <div
        style={STYLES.main}
        ref={r => {
          this.container = r;
        }}
        className="Films--film_filter_editor"
      >
        <div style={STYLES.container}>
          <label htmlFor="filmFilterTextbox" style={STYLES.filterBox}>
            <SearchIcon
              style={Object.assign(
                {},
                STYLES.icon,
                Radium.getState(this.state, "input", ":focus") && selectedStyle
              )}
            />
            <input
              tabIndex={1}
              id="filmFilterTextbox"
              key="input"
              type="text"
              placeholder={
                isLarge
                  ? "Search for films by title, details, credits..."
                  : "Search for films..."
              }
              style={STYLES.input}
              value={this.state.search}
              onChange={this._onSearchChange}
              ref={r => {
                this.input = r;
              }}
            />
          </label>
          <div style={STYLES.viewControl}>
            {this.state.search ? (
              <IconButton
                tooltip="Clear"
                style={STYLES.viewIcon}
                onClick={() => this._onSearchChange({ target: { value: "" } })}
              >
                <ClearIcon />
              </IconButton>
            ) : (
              <span>
                <IconButton
                  tooltip="My starred films"
                  style={STYLES.viewIcon}
                  onClick={this.props.onStarredChange}
                  iconStyle={
                    this.props.starred ? selectedStyle : unselectedStyle
                  }
                >
                  {this.props.starred ? <StarIcon /> : <StarBorderIcon />}
                </IconButton>
                {!forcedListMode && (
                  <IconButton
                    tooltip="Grid view"
                    style={STYLES.viewIcon}
                    onClick={() => this.props.onModeChange("grid")}
                    iconStyle={
                      this.props.mode === "grid"
                        ? selectedStyle
                        : unselectedStyle
                    }
                  >
                    <ViewModuleIcon />
                  </IconButton>
                )}
                <IconButton
                  tooltip="List view"
                  style={STYLES.viewIcon}
                  onClick={() => this.props.onModeChange("list")}
                  iconStyle={
                    this.props.mode === "list" ? selectedStyle : unselectedStyle
                  }
                >
                  <ViewListIcon />
                </IconButton>
              </span>
            )}
          </div>
        </div>
        {tagComponents.length ? (
          <div
            className="Films--film_filter_editor--tags"
            style={[
              STYLES.subContainer,
              (!scrolledPastFilterEditor /* || mainHovered */ ||
                inputFocused ||
                hasTagFilters) &&
                STYLES.subContainerActive,
              displaySectionMode && STYLES.subContainerDisplaySectionMode
            ]}
          >
            {tagComponents}
          </div>
        ) : null}
      </div>
    );
  }
}

export default Radium(FilmFilterEditor);



// WEBPACK FOOTER //
// ./src/app/components/partials/film-list/film-filter-editor.jsx